import { publicEnv } from "@/lib/env";

let tenantInfo = null;

export type TenantInfo = {
    appName: string;
    provider: string;
    favicon: string;
    logo: string;
    contact: string;
};

export function getTenantInfo(): TenantInfo {
    if (tenantInfo == null) {
        switch (publicEnv("TENANT")) {
            case "bippit": {
                tenantInfo = {
                    appName: "admin portal",
                    provider: "Bippit",
                    favicon: "/b/favicon.ico",
                    logo: "/b/logo.png",
                    contact: "support@bippit.com",
                };
                break;
            }
            case "evelyn": {
                tenantInfo = {
                    appName: "admin portal",
                    provider: "Moneyhealth",
                    favicon: "/e/favicon.ico",
                    logo: "/e/logo.png",
                    contact: "support@moneyhealth.evelyn.com",
                };
                break;
            }
            default: {
                tenantInfo = {
                    appName: "admin portal",
                    provider: "Coaching Services",
                    favicon: "/d/favicon.ico",
                    logo: "/d/logo.png",
                    contact: "support@bippit.com",
                };
                break;
            }
        }
    }

    return tenantInfo;
}
